/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDTOListPaymentMethodEnum } from "../models/ApiResponseDTOListPaymentMethodEnum";
import type { ApiResponseDTOListStatusEnum } from "../models/ApiResponseDTOListStatusEnum";
import type { ApiResponseDTOListTerminalActivityDTO } from "../models/ApiResponseDTOListTerminalActivityDTO";
import type { ApiResponseDTOMerchantStaticAccountRecord } from "../models/ApiResponseDTOMerchantStaticAccountRecord";
import type { ApiResponseDTONameInquiryResRecord } from "../models/ApiResponseDTONameInquiryResRecord";
import type { ApiResponseDTOOperationDTO } from "../models/ApiResponseDTOOperationDTO";
import type { ApiResponseDTOOperationFullDTO } from "../models/ApiResponseDTOOperationFullDTO";
import type { ApiResponseDTOOperationResFeeRecord } from "../models/ApiResponseDTOOperationResFeeRecord";
import type { ApiResponseDTOPaginationRecordListOperationBaseDTO } from "../models/ApiResponseDTOPaginationRecordListOperationBaseDTO";
import type { ApiResponseDTOPaginationRecordListSalesItemDTO } from "../models/ApiResponseDTOPaginationRecordListSalesItemDTO";
import type { ApiResponseDTOPendingBalanceResRecord } from "../models/ApiResponseDTOPendingBalanceResRecord";
import type { ApiResponseDTOSalesSummaryRecord } from "../models/ApiResponseDTOSalesSummaryRecord";
import type { ApiResponseDTOSaleTransfersRecord } from "../models/ApiResponseDTOSaleTransfersRecord";
import type { BankTransferRecord } from "../models/BankTransferRecord";
import type { ConfirmSaleRequestRecord } from "../models/ConfirmSaleRequestRecord";
import type { NameInquiryRecord } from "../models/NameInquiryRecord";
import type { OperationFeeRecord } from "../models/OperationFeeRecord";
import type { OperationMobileRefundRecord } from "../models/OperationMobileRefundRecord";
import type { OperationOutBankTransferRecord } from "../models/OperationOutBankTransferRecord";
import type { OperationReqBaseDTO } from "../models/OperationReqBaseDTO";
import type { OperationReqUssdDTO } from "../models/OperationReqUssdDTO";
import type { PayOnlyOperationReqBaseDTO } from "../models/PayOnlyOperationReqBaseDTO";
import type { PayOnlyOperationReqMomoDTO } from "../models/PayOnlyOperationReqMomoDTO";
import type { PayOnlyOperationReqUssdDTO } from "../models/PayOnlyOperationReqUssdDTO";
import type { ServerSentEventApiResponseDTOOperationFullDTO } from "../models/ServerSentEventApiResponseDTOOperationFullDTO";
import type { ShareReceiptEmailReqDTO } from "../models/ShareReceiptEmailReqDTO";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class OperationsApiService {
  /**
   * Get Operations
   * Retrieves a paginated list of operations using filters.
   * @param page Which page should be selected.
   * @param size Number of records to select
   * @param direction Indicates whether the content should be sorted ascending or descending
   * @param orderBy Indicates which column should be taken into consideration when sorting
   * @param operationDateStart Indicates that transactions with a date greater than or equal to this field will be filtered
   * @param operationDateEnd Indicates that transactions with a date less than or equal to this field will be filtered
   * @param paymentMethods Indicates what payment method should be filtered
   * @param minimumAmount Indicates that transactions with an amount equal to or greater than the value contained in this field will be filtered
   * @param maximumAmount Indicates that transactions with an amount equal to or less than the value contained in this field sill be filtered
   * @param status Indicates what operation status should be filtered
   * @returns ApiResponseDTOPaginationRecordListOperationBaseDTO OK
   * @throws ApiError
   */
  public static getOperations(
    page?: string,
    size?: string,
    direction?: string,
    orderBy?: string,
    operationDateStart?: string,
    operationDateEnd?: string,
    paymentMethods?: string,
    minimumAmount?: string,
    maximumAmount?: string,
    status?: string,
    outletId?: string
  ): CancelablePromise<ApiResponseDTOPaginationRecordListOperationBaseDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/operation",
      query: {
        page: page,
        size: size,
        direction: direction,
        orderBy: orderBy,
        operationDateStart: operationDateStart,
        operationDateEnd: operationDateEnd,
        paymentMethods: paymentMethods,
        minimumAmount: minimumAmount,
        maximumAmount: maximumAmount,
        status: status,
        outletId: outletId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Export Operations List
   * Retrieves a list of operations, generate and export it.
   * @param mediaType Indicates what is the export file type
   * @param page Which page should be selected.
   * @param size Number of records to select
   * @param direction Indicates whether the content should be sorted ascending or descending
   * @param orderBy Indicates which column should be taken into consideration when sorting
   * @param operationDateStart Indicates that transactions with a date greater than or equal to this field will be filtered
   * @param operationDateEnd Indicates that transactions with a date less than or equal to this field will be filtered
   * @param paymentMethods Indicates what payment method should be filtered
   * @param minimumAmount Indicates that transactions with an amount equal to or greater than the value contained in this field will be filtered
   * @param maximumAmount Indicates that transactions with an amount equal to or less than the value contained in this field sill be filtered
   * @param status Indicates what operation status should be filtered
   * @returns any OK
   * @throws ApiError
   */
  public static exportOperations(
    mediaType?: string,
    page?: string,
    size?: string,
    direction?: string,
    orderBy?: string,
    operationDateStart?: string,
    operationDateEnd?: string,
    paymentMethods?: string,
    minimumAmount?: string,
    maximumAmount?: string,
    status?: string,
    outletId?: string
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/operation/export",
      query: {
        mediaType: mediaType,
        page: page,
        size: size,
        direction: direction,
        orderBy: orderBy,
        operationDateStart: operationDateStart,
        operationDateEnd: operationDateEnd,
        paymentMethods: paymentMethods,
        minimumAmount: minimumAmount,
        maximumAmount: maximumAmount,
        status: status,
        outletId: outletId,
      },
      errors: {
        500: `Internal Server Error`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Post Operation Fee
   * Retrieves the fee that will be applied to the pretended operation
   * @param requestBody
   * @returns ApiResponseDTOOperationResFeeRecord OK
   * @throws ApiError
   */
  public static postOperationFee(
    requestBody: OperationFeeRecord
  ): CancelablePromise<ApiResponseDTOOperationResFeeRecord> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/operation/fee",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Post Operation IN Bank Transfer
   * Create a operation with all the request data.
   * @param deviceChannel
   * @param requestBody
   * @returns ApiResponseDTOOperationDTO Created
   * @throws ApiError
   */
  public static postOperationInBankTransfer(
    deviceChannel: "WEB" | "POS" | "MOBILE" | "AGGREGATOR",
    requestBody: OperationReqBaseDTO
  ): CancelablePromise<ApiResponseDTOOperationDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/operation/in/bank-transfer",
      headers: {
        deviceChannel: deviceChannel,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Post Operation IN Bank Transfer
   * Create a operation with all the request data.
   * @param deviceChannel
   * @param requestBody
   * @returns ApiResponseDTOOperationDTO Created
   * @throws ApiError
   */
  public static postOperationInBankTransfer1(
    deviceChannel: "WEB" | "POS" | "MOBILE" | "AGGREGATOR",
    requestBody: PayOnlyOperationReqBaseDTO
  ): CancelablePromise<ApiResponseDTOOperationDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/operation/in/bank-transfer/pay-only",
      headers: {
        deviceChannel: deviceChannel,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Post Operation POS-CARD
   * Create a operation with all the request data.
   * @param deviceChannel
   * @param requestBody
   * @returns ApiResponseDTOOperationDTO Created
   * @throws ApiError
   */
  public static postOperationPosCard(
    deviceChannel: "WEB" | "POS" | "MOBILE" | "AGGREGATOR",
    requestBody: OperationReqBaseDTO
  ): CancelablePromise<ApiResponseDTOOperationDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/operation/in/card",
      headers: {
        deviceChannel: deviceChannel,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Post Operation POS-Card
   * Create a operation with all the request data.
   * @param deviceChannel
   * @param requestBody
   * @returns ApiResponseDTOOperationDTO Created
   * @throws ApiError
   */
  public static postOperationPosCard1(
    deviceChannel: "WEB" | "POS" | "MOBILE" | "AGGREGATOR",
    requestBody: PayOnlyOperationReqBaseDTO
  ): CancelablePromise<ApiResponseDTOOperationDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/operation/in/card/pay-only",
      headers: {
        deviceChannel: deviceChannel,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Post Operation Cash
   * Create a operation with all the request data.
   * @param deviceChannel
   * @param requestBody
   * @returns ApiResponseDTOOperationDTO Created
   * @throws ApiError
   */
  public static postOperationCash(
    deviceChannel: "WEB" | "POS" | "MOBILE" | "AGGREGATOR",
    requestBody: OperationReqBaseDTO
  ): CancelablePromise<ApiResponseDTOOperationDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/operation/in/cash",
      headers: {
        deviceChannel: deviceChannel,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Post Cash Operation Without Sale Items
   * Create a operation with all the request data.
   * @param deviceChannel
   * @param requestBody
   * @returns ApiResponseDTOOperationDTO Created
   * @throws ApiError
   */
  public static postOperationCash1(
    deviceChannel: "WEB" | "POS" | "MOBILE" | "AGGREGATOR",
    requestBody: PayOnlyOperationReqBaseDTO
  ): CancelablePromise<ApiResponseDTOOperationDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/operation/in/cash/pay-only",
      headers: {
        deviceChannel: deviceChannel,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Post Operation Momo
   * Create a operation with all the request data.
   * @param deviceChannel
   * @param requestBody
   * @returns ApiResponseDTOOperationDTO Created
   * @throws ApiError
   */
  public static postOperationMomo(
    deviceChannel: "WEB" | "POS" | "MOBILE" | "AGGREGATOR",
    requestBody: PayOnlyOperationReqMomoDTO
  ): CancelablePromise<ApiResponseDTOOperationDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/operation/in/momo/pay-only",
      headers: {
        deviceChannel: deviceChannel,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Post Operation IN Payment Link
   * Create a operation with all the request data.
   * @param deviceChannel
   * @param requestBody
   * @returns ApiResponseDTOOperationDTO Created
   * @throws ApiError
   */
  public static postOperationPaymentLink(
    deviceChannel: "WEB" | "POS" | "MOBILE" | "AGGREGATOR",
    requestBody: OperationReqBaseDTO
  ): CancelablePromise<ApiResponseDTOOperationDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/operation/in/payment-link",
      headers: {
        deviceChannel: deviceChannel,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Post Operation IN Payment Link
   * Create a operation with all the request data.
   * @param deviceChannel
   * @param requestBody
   * @returns ApiResponseDTOOperationDTO Created
   * @throws ApiError
   */
  public static postOperationPaymentLink1(
    deviceChannel: "WEB" | "POS" | "MOBILE" | "AGGREGATOR",
    requestBody: PayOnlyOperationReqBaseDTO
  ): CancelablePromise<ApiResponseDTOOperationDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/operation/in/payment-link/pay-only",
      headers: {
        deviceChannel: deviceChannel,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Post Operation QR Code
   * Create a operation with all the request data.
   * @param deviceChannel
   * @param requestBody
   * @returns ApiResponseDTOOperationDTO Created
   * @throws ApiError
   */
  public static postOperationQrCode(
    deviceChannel: "WEB" | "POS" | "MOBILE" | "AGGREGATOR",
    requestBody: OperationReqBaseDTO
  ): CancelablePromise<ApiResponseDTOOperationDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/operation/in/qr-code",
      headers: {
        deviceChannel: deviceChannel,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Post Operation QR Code
   * Create a operation with all the request data.
   * @param deviceChannel
   * @param requestBody
   * @returns ApiResponseDTOOperationDTO Created
   * @throws ApiError
   */
  public static postOperationQrCode1(
    deviceChannel: "WEB" | "POS" | "MOBILE" | "AGGREGATOR",
    requestBody: PayOnlyOperationReqBaseDTO
  ): CancelablePromise<ApiResponseDTOOperationDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/operation/in/qr-code/pay-only",
      headers: {
        deviceChannel: deviceChannel,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Post Operation USSD
   * Create a operation with all the request data.
   * @param deviceChannel
   * @param requestBody
   * @returns ApiResponseDTOOperationDTO Created
   * @throws ApiError
   */
  public static postOperationUssd(
    deviceChannel: "WEB" | "POS" | "MOBILE" | "AGGREGATOR",
    requestBody: OperationReqUssdDTO
  ): CancelablePromise<ApiResponseDTOOperationDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/operation/in/ussd",
      headers: {
        deviceChannel: deviceChannel,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Post Operation USSD
   * Create a operation with all the request data.
   * @param deviceChannel
   * @param requestBody
   * @returns ApiResponseDTOOperationDTO Created
   * @throws ApiError
   */
  public static postOperationUssd1(
    deviceChannel: "WEB" | "POS" | "MOBILE" | "AGGREGATOR",
    requestBody: PayOnlyOperationReqUssdDTO
  ): CancelablePromise<ApiResponseDTOOperationDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/operation/in/ussd/pay-only",
      headers: {
        deviceChannel: deviceChannel,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Get Sales Items
   * Retrieves a paginated list of sales item using filters.
   * @param page Which page should be selected.
   * @param size Number of records to select
   * @param startDate Indicates that items with a date greater than or equal to this field will be filtered
   * @param endDate Indicates that items with a date less than or equal to this field will be filtered
   * @param paymentMethods Indicates what payment method should be filtered
   * @param minimumAmount Indicates that items with an amount equal to or greater than the value contained in this field will be filtered
   * @param maximumAmount Indicates that items with an amount equal to or less than the value contained in this field sill be filtered
   * @param description Indicates that only the items that match with this field will be filtered
   * @param status Indicates what operation status should be filtered
   * @param initiatorIds Sales made by these users: an employee's user id, or the merchant's own id for their own sales
   * @returns ApiResponseDTOPaginationRecordListSalesItemDTO OK
   * @throws ApiError
   */
  public static getSalesItems(
    page?: string,
    size?: string,
    startDate?: string,
    endDate?: string,
    paymentMethods?: string,
    minimumAmount?: string,
    maximumAmount?: string,
    description?: string,
    status?: string,
    initiatorIds?: string
  ): CancelablePromise<ApiResponseDTOPaginationRecordListSalesItemDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/operation/items",
      query: {
        page: page,
        size: size,
        startDate: startDate,
        endDate: endDate,
        paymentMethods: paymentMethods,
        minimumAmount: minimumAmount,
        maximumAmount: maximumAmount,
        description: description,
        status: status,
        initiatorIds: initiatorIds,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Get the Sales Items summary
   * The count and total value of completed sales among the sale items the same filters list. Only SUCCESS sales count, whatever status is asked for: undone, pending and expired sales never do.
   * @param page Which page should be selected.
   * @param size Number of records to select
   * @param startDate Indicates that items with a date greater than or equal to this field will be filtered
   * @param endDate Indicates that items with a date less than or equal to this field will be filtered
   * @param paymentMethods Indicates what payment method should be filtered
   * @param minimumAmount Indicates that items with an amount equal to or greater than the value contained in this field will be filtered
   * @param maximumAmount Indicates that items with an amount equal to or less than the value contained in this field sill be filtered
   * @param description Indicates that only the items that match with this field will be filtered
   * @param status Indicates what operation status should be filtered
   * @param initiatorIds Only the sales made by these users: an employee's id, or the merchant's for their own sales
   * @returns ApiResponseDTOSalesSummaryRecord OK
   * @throws ApiError
   */
  public static getSalesItemsSummary(
    page?: string,
    size?: string,
    startDate?: string,
    endDate?: string,
    paymentMethods?: string,
    minimumAmount?: string,
    maximumAmount?: string,
    description?: string,
    status?: string,
    initiatorIds?: string
  ): CancelablePromise<ApiResponseDTOSalesSummaryRecord> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/operation/items/summary",
      query: {
        page: page,
        size: size,
        startDate: startDate,
        endDate: endDate,
        paymentMethods: paymentMethods,
        minimumAmount: minimumAmount,
        maximumAmount: maximumAmount,
        description: description,
        status: status,
        initiatorIds: initiatorIds,
      },
      errors: {
        500: `Internal Server Error`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Mobile OUT Bank Transfer
   * Initiates an outbound bank transfer from a mobile device. Validates PIN for all transactions; additionally validates OTP when amount exceeds the configured high-value threshold.
   * @param requestBody
   * @returns ApiResponseDTOOperationDTO Created
   * @throws ApiError
   */
  public static postMobileOperationOutBankTransfer(
    requestBody: OperationOutBankTransferRecord
  ): CancelablePromise<ApiResponseDTOOperationDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/operation/mobile/out/bank-transfer",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Mobile OUT Refund
   * Initiates a mobile refund operation. Validates PIN for all transactions; additionally validates OTP when amount exceeds the configured high-value threshold.
   * @param requestBody
   * @returns ApiResponseDTOOperationDTO Created
   * @throws ApiError
   */
  public static postMobileOperationOutRefund(
    requestBody: OperationMobileRefundRecord
  ): CancelablePromise<ApiResponseDTOOperationDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/operation/mobile/out/refund",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Post Operation Name Enquiry
   * Create a operation with all the request data.
   * @param deviceChannel
   * @param requestBody
   * @returns ApiResponseDTONameInquiryResRecord Created
   * @throws ApiError
   */
  public static postOperationNameEnquiry(
    deviceChannel: "WEB" | "POS" | "MOBILE" | "AGGREGATOR",
    requestBody: NameInquiryRecord
  ): CancelablePromise<ApiResponseDTONameInquiryResRecord> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/operation/name-inquiry",
      headers: {
        deviceChannel: deviceChannel,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Post Operation OUT Bank Transfer
   * Create a operation with all the request data.
   * @param deviceChannel
   * @param requestBody
   * @returns ApiResponseDTOOperationDTO Created
   * @throws ApiError
   */
  public static postOperationOutBankTransfer(
    deviceChannel: "WEB" | "POS" | "MOBILE" | "AGGREGATOR",
    requestBody: OperationOutBankTransferRecord
  ): CancelablePromise<ApiResponseDTOOperationDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/operation/out/bank-transfer",
      headers: {
        deviceChannel: deviceChannel,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Post Operation Refund
   * Create a operation with all the request data.
   * @param deviceChannel
   * @param requestBody
   * @returns ApiResponseDTOOperationDTO Created
   * @throws ApiError
   */
  public static postOperationRefund(
    deviceChannel: "WEB" | "POS" | "MOBILE" | "AGGREGATOR",
    requestBody: BankTransferRecord
  ): CancelablePromise<ApiResponseDTOOperationDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/operation/out/refund",
      headers: {
        deviceChannel: deviceChannel,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Get List of Operation Payment Method
   * Retrieves the operation payment Method list.
   * @returns ApiResponseDTOListPaymentMethodEnum OK
   * @throws ApiError
   */
  public static getListPaymentMethod1(): CancelablePromise<ApiResponseDTOListPaymentMethodEnum> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/operation/payment-method",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Get Pending Balance
   * Retrieves the pending balance of unpaid operations with Pending status.
   * @param walletId Repeatable; the wallets to total. Omit for the signed-in one.
   * @returns ApiResponseDTOPendingBalanceResRecord OK
   * @throws ApiError
   */
  public static getPendingBalance(
    walletId?: Array<string>
  ): CancelablePromise<ApiResponseDTOPendingBalanceResRecord> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/operation/pending-balance",
      query: {
        walletId: walletId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Get Transactions for Logged in User
   * Retrieves a paginated list of transactions for logged in user using filters.
   * @param page Which page should be selected.
   * @param size Number of records to select
   * @param direction Indicates whether the content should be sorted ascending or descending
   * @param orderBy Indicates which column should be taken into consideration when sorting
   * @param operationDateStart Indicates that transactions with a date greater than or equal to this field will be filtered
   * @param operationDateEnd Indicates that transactions with a date less than or equal to this field will be filtered
   * @param paymentMethods Indicates what payment method should be filtered
   * @param minimumAmount Indicates that transactions with an amount equal to or greater than the value contained in this field will be filtered
   * @param maximumAmount Indicates that transactions with an amount equal to or less than the value contained in this field sill be filtered
   * @param status Indicates what operation status should be filtered
   * @returns ApiResponseDTOPaginationRecordListOperationBaseDTO OK
   * @throws ApiError
   */
  public static getUserSessionTransactions(
    page?: string,
    size?: string,
    direction?: string,
    orderBy?: string,
    operationDateStart?: string,
    operationDateEnd?: string,
    paymentMethods?: string,
    minimumAmount?: string,
    maximumAmount?: string,
    status?: string
  ): CancelablePromise<ApiResponseDTOPaginationRecordListOperationBaseDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/operation/session/transaction-details",
      query: {
        page: page,
        size: size,
        direction: direction,
        orderBy: orderBy,
        operationDateStart: operationDateStart,
        operationDateEnd: operationDateEnd,
        paymentMethods: paymentMethods,
        minimumAmount: minimumAmount,
        maximumAmount: maximumAmount,
        status: status,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Get List of Operation Status
   * Retrieves the operation status list.
   * @returns ApiResponseDTOListStatusEnum OK
   * @throws ApiError
   */
  public static getListStatus(): CancelablePromise<ApiResponseDTOListStatusEnum> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/operation/status",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Check for terminal transactions
   * Retrieves a list of terminals and their activity state.
   * @param xApiKey
   * @param requestBody
   * @returns ApiResponseDTOListTerminalActivityDTO OK
   * @throws ApiError
   */
  public static getTerminalActivity(
    xApiKey: string,
    requestBody: Array<string>
  ): CancelablePromise<ApiResponseDTOListTerminalActivityDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/operation/terminal/terminal-activities",
      headers: {
        "X-API-KEY": xApiKey,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Get Operation by operationID
   * Retrieves the Operation that has the inserted ID.
   * @param operationId
   * @returns ApiResponseDTOOperationFullDTO OK
   * @throws ApiError
   */
  public static getOperationId(
    operationId: string
  ): CancelablePromise<ApiResponseDTOOperationFullDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/operation/{operationId}",
      path: {
        operationId: operationId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Get Payment Operation Detail by operationId
   * Retrieves the Operation detail in the exact format as the original creation response.
   * @param operationId
   * @returns ApiResponseDTOOperationDTO OK
   * @throws ApiError
   */
  public static getPaymentOperationDetail(
    operationId: string
  ): CancelablePromise<ApiResponseDTOOperationDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/operation/{operationId}/detail",
      path: {
        operationId: operationId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * @param operationId
   * @returns ApiResponseDTOOperationFullDTO OK
   * @throws ApiError
   */
  public static getOperationLongPolling(
    operationId: string
  ): CancelablePromise<ApiResponseDTOOperationFullDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/operation/{operationId}/poll",
      path: {
        operationId: operationId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Export Operations Receipt
   * Export Operation Receipt in PDF
   * @param operationId
   * @returns any OK
   * @throws ApiError
   */
  public static exportReceipt(operationId: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/operation/{operationId}/receipt",
      path: {
        operationId: operationId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Share Operation Receipt
   * Share Operation Receipt
   * @param operationId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static shareReceipt(
    operationId: string,
    requestBody: ShareReceiptEmailReqDTO
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/operation/{operationId}/receipt/share",
      path: {
        operationId: operationId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * @param operationId
   * @returns ServerSentEventApiResponseDTOOperationFullDTO OK
   * @throws ApiError
   */
  public static operationSse(
    operationId: string
  ): CancelablePromise<Array<ServerSentEventApiResponseDTOOperationFullDTO>> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/operation/{operationId}/sse",
      path: {
        operationId: operationId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Post Operation Static Account
   * Creates a sale the customer pays into the merchant's static account, when the merchant reaches the Summary page. The sale is PENDING until the merchant confirms it (POST /{operationId}/confirm) within the hour given by expiresAt; inBankTransfer carries the account to pay into. 400 ZENZ_TRANSACTION_028 unless the Static Account preference is on and the account is switched on.
   * @param deviceChannel
   * @param requestBody
   * @returns ApiResponseDTOOperationDTO Created
   * @throws ApiError
   */
  public static postOperationStaticAccount(
    deviceChannel: "WEB" | "POS" | "MOBILE" | "AGGREGATOR" | "BACKOFFICE",
    requestBody: OperationReqBaseDTO
  ): CancelablePromise<ApiResponseDTOOperationDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/operation/in/static-account",
      headers: {
        deviceChannel: deviceChannel,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Confirm a cash or static account sale
   * The merchant confirms they have the money for a PENDING cash or static account sale. A static account sale is confirmed with the transfer that paid for it (transferId, one GET /{operationId}/transfers lists); cash sends no body. Within its window the sale becomes SUCCESS with a receipt number and is recorded in inventory and analytics; after it, 422 ZENZ_TRANSACTION_054 ("This payment has expired."). Confirming an already confirmed sale returns it unchanged. Confirm Later needs no call.
   * @param operationId
   * @param requestBody
   * @returns ApiResponseDTOOperationDTO OK
   * @throws ApiError
   */
  public static confirmSale(
    operationId: string,
    requestBody?: ConfirmSaleRequestRecord
  ): CancelablePromise<ApiResponseDTOOperationDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/operation/{operationId}/confirm",
      path: {
        operationId: operationId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Static account sale without transferId`,
        404: `Not Found`,
        409: `Not a sale the merchant confirms, not awaiting confirmation, or a transfer that can no longer be used for it`,
        422: `This payment has expired.`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Transfers a static account sale can be confirmed with
   * Transfers into the sale's static account of exactly the sale total, received or pending credit, not yet used for a sale, not refunded, and received within the last 24 hours (zenz.static-account.transfer-window). Newest first.
   * @param operationId
   * @returns ApiResponseDTOSaleTransfersRecord OK
   * @throws ApiError
   */
  public static getSaleTransfers(
    operationId: string
  ): CancelablePromise<ApiResponseDTOSaleTransfersRecord> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/operation/{operationId}/transfers",
      path: {
        operationId: operationId,
      },
      errors: {
        404: `Not Found`,
        409: `Not a pending static account sale`,
        422: `This payment has expired.`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }

  /**
   * Get the outlet's static account
   * The account customers pay into at checkout: the one of the outlet wallet the merchant or employee is signed in on. Returned whether it is switched on or off. An outlet without one gets it now, in the state of the merchant's other accounts; 404 (ZENZ_TRANSACTION_051) when the merchant has never enabled it.
   * @returns ApiResponseDTOMerchantStaticAccountRecord OK
   * @throws ApiError
   */
  public static getMerchantStaticAccount(): CancelablePromise<ApiResponseDTOMerchantStaticAccountRecord> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/static-account",
      errors: {
        404: `The merchant has no static account`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }
}
